import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import PalletPlantsList from '../../components/pallets/PalletPlants/PalletPlantsList';
import PalletPlantsHeader from '../../components/pallets/PalletPlants/PalletPlantsHeader';

import { useSessionContext } from '../../contexts/SessionContext';

export default function PalletPlantsPage( props ){
    //console.debug("RTS Break PalletPlantsPage");

    const {userAuthToken, apiRoot} = useSessionContext();

    const [data, setData] = useState([]);

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const fetchData = useCallback(() => {
        let apiURL = apiRoot + "/PalletPlants/GetAllPalletPlants";
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        fetchData();
    }, [props, fetchData]);  
    

    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box id="pageBox">
            <PalletPlantsHeader />
            <Box sx={{mt:2}}>           
                <PalletPlantsList data={data} />
            </Box>
        </Box>
    );
}
